<script>
    import { push } from 'svelte-spa-router';
    export let href = '';
    export let text = '';
    const stickyMenuHeight = 110; // Hauteur du menu sticky
  
    function scrollToHash(hash) {
      const element = document.querySelector(hash);
      if (element) {
        const offsetTop = element.getBoundingClientRect().top + window.pageYOffset - stickyMenuHeight;
        window.scrollTo({ top: offsetTop, behavior: 'smooth' });
      }
    }
  
    function navigate(event) {
      event.preventDefault();
      if (href.startsWith('#')) {
        scrollToHash(href);
      } else {
        push(href);
      }
    }
  </script>
  
  <a href={href} on:click={navigate}>{text}</a>
  